import { render } from "./ConfReserva.vue?vue&type=template&id=5990f358"
import script from "./ConfReserva.vue?vue&type=script&lang=js"
export * from "./ConfReserva.vue?vue&type=script&lang=js"

import "./ConfReserva.vue?vue&type=style&index=0&id=5990f358&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__